import Vue from 'vue'
import Router from 'vue-router'
import question from '../components/question/question'
import help from '../components/help/help'
import photoSwipeTest from '../components/photo-swipe-test/photo-swipe-test'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'question',
      component: question
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/photoSwipeTest',
      name: 'photoSwipeTest',
      component: photoSwipeTest
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js